// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.counter-badge[data-v-38b36bb7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  min-width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #e84545;\n  color: white;\n  text-align: center;\n  font-weight: 600;\n  font-size: 11px;\n}\n", ""]);
// Exports
module.exports = exports;
